module.exports = __webpack_public_path__ + "img/technology-5.9ad615aa.png";